import React from 'react'
import PropTypes from 'prop-types'

import Table from '../components/Table'

const InfoTable = ({ data, ...otherProps }) => {
    const columns = [
        { key: 'title', className: 'info-table-title' },
        { key: 'value' }
    ]

    return (
        <Table
            columns={ columns }
            data={ data }
            isStriped={ false }
            withHeader={ false }
            withBorders={ false }
            withNumbers={ false }
            withHover={ false }
            { ...otherProps }
        />
    )
}

InfoTable.propTypes = {
    columns : PropTypes.arrayOf(PropTypes.object),
    data    : PropTypes.arrayOf(PropTypes.object)
}

export default InfoTable
